<template>
  <b-container class="mw-100 mt-3">
    <b-card class="mt-4 mb-4">
      <standard-table ref="driversTable"
                      search-id="staff-search"
                      :items="driverItems"
                      :fields="driverFields"
                      :search-place-holder="`${$tc('message.example', 1)}: AA999ZZ`"

                      :row-before-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 1,orderMd: 1,orderLg: 3,orderXl: 3}"
                      :row-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"
                      :row-after-search="{cols: 12, sm: 12, md: 12, lg: 4, xl: 4, order: 2, orderSm: 3, orderMd: 3, orderLg: 2, orderXl: 2}"

                      :after-search="{cols: 12, sm: 12, md: 12, lg: 12, xl: 12}"

                      :row-pagination="{cols: 12, sm: 12, md: 6, lg: 5, xl: 5}"
                      :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 1, xl: 4}"
                      :row-per-page="{cols: 12, sm: 12, md: 5, lg: 3, xl: 2}"
                      :row-after-per-page="{cols: 12, sm: 12, md: 12, lg: 3, xl: 1}"

                      :search-label-horizontal="false"
                      fullWidth="true"
                      noContainerPadding="true"

                      @rowEdit="pushToEdit($event.item)"
                      @rowDelete="deleteSelected($event.item.id, `${$tc('message.staff', 1)}`)">

        <b-container slot="row-before-search" class="mw-100 p-0">
          <b-row align-h="end">
            <b-col cols="auto">
              <!-- config[crud], create - read - update - delete -->
              <b-button @click="showImportModal" class="b-c-blue mb-3" v-if="config.c || config.u">
                <span>{{$t('message.import')}}</span>
              </b-button>
            </b-col>

            <b-col cols="auto">
              <!-- config[crud], create - read - update - delete -->
              <b-button v-on:click="pushToEdit()" class="b-c-blue mb-3" id="add-staff" v-if="config.c">
                {{$t('message.add')}}
              </b-button>
            </b-col>
          </b-row>
        </b-container>

        <b-container slot="row-after-search" class="mw-100 p-0 ">
          <b-row>
            <b-col cols="auto">
              <b-button v-on:click="resetFilters()" class="b-c-green" id="reset-filters">
                {{$t('message.resetFilters')}}
              </b-button>
            </b-col>

            <b-col cols="auto" class="mb-3">
              <b-button @click="showCollapse = !showCollapse" :class="showCollapse ? 'b-c-red' : 'b-c-green'">
                <span v-show="!showCollapse" class="when-opened">
                  {{$t('message.show')}} {{$tc('message.filter', 2).toLowerCase()}}
                </span>
                <span v-show="showCollapse" class="when-closed">
                  {{$t('message.hide')}} {{$tc('message.filter', 2).toLowerCase()}}
                </span>
              </b-button>
            </b-col>
          </b-row>
        </b-container>

        <b-container slot="after-search" class="mw-100 p-0">
          <b-collapse id="my-collapse" v-model="showCollapse">
            <b-container class="mw-100 m-0 p-0">
              <b-row>
                <b-col cols="12" sm="4" md="4" lg="4" xl="4">
                  <b-form-group :label="`${$tc('message.drivingLicense', 1)}`"
                                label-for="input-vehicle">
                    <model-list-select id="input-vehicle"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="drivingLicenseOptions && drivingLicenseOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="drivingLicenseFilter"
                                       :list="drivingLicenseOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="4" md="4" lg="4" xl="4">
                  <b-form-group :label="$tc('message.society', 1)"
                                label-for="input-driver">
                    <model-list-select id="input-driver"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="companyOptions && companyOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="companyFilter"
                                       :list="companyOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="4" md="4" lg="4" xl="4">
                  <b-form-group :label="$tc('message.resigned', 1)"
                                label-for="input-mails">
                    <model-list-select id="input-mails"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="enabledDriverOptions && enabledDriverOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="enabledDriverFilter"
                                       :list="enabledDriverOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-container>
          </b-collapse>
        </b-container>

        <b-container slot="row-after-per-page" class="mw-100 p-0">
          <b-row>
            <b-col>
              <b-button class="float-right mt-3 mt-md-0 mt-lg-0 mt-xl-0"
                        id="excel-button" @click="$refs.driversTable.excel($tc('message.staff', 1))"> Excel
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </standard-table>
    </b-card>

    <b-modal ref="importModal" id="importModal" :title="`${$t('message.import')} ${$t('message.staff', 1).toLowerCase()}`">
      <b-container>
        <b-row>
          <b-col cols="12">
            <!-- Document -->
            <b-form-group label="Excel" label-for="import-staff-file">
              <b-form-file v-model="staffImportFile"
                           id="import-staff-file"
                           ref="importStaffFile"
                           accept=".xlsx, .xls .ods"
                           v-on:input="driverFileImported"
                           :placeholder="$t('message.selectFile')">
              </b-form-file>
            </b-form-group>
          </b-col>
        </b-row>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button class="b-c-green mr-2" v-on:click="startImport(staffImportFile)" :disabled="!enableImport">{{$t('message.import')}}</b-button>

        <b-button class="b-c-green mr-3" v-on:click="closeImportModal()">{{$t('message.close')}}</b-button>
      </div>
    </b-modal>

    <b-modal ref="importModalErrors" id="importModalErrors" :title="`${$t('message.caution')}!`"
             no-close-on-backdrop no-close-on-esc hide-header-close @shown="$root.$emit('activeLoader', false)">
      <b-container>
        <b-row>
          <b-col>
            <h4>{{$t('errors.errorsList')}}:</h4>
          </b-col>
        </b-row>

        <b-row>
          <b-container>
            <b-list-group>
              <b-list-group-item v-for="(item, index) in importErrors" :key="index">
                <b-row>
                  <b-col cols="10" sm="10" v-if="item.driver">
                    <h6 class="c-red font-weight-bold">{{$tc('message.row', 1)}}: {{item.driver.index}}</h6>
                    <h6 class="c-red font-weight-bold">{{item.driver.surname}} {{item.driver.name}} {{item.driver.taxCode ? `- ${item.driver.taxCode}` : ''}}</h6>
                  </b-col>

                  <b-col cols="10" sm="10">
                    <div v-for="(message, index) in item.errors" :key="index">
                      <h6 class="c-red font-italic">- {{message}} </h6>
                    </div>
                  </b-col>
                </b-row>
              </b-list-group-item>
            </b-list-group>
          </b-container>
        </b-row>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button id="nw-ok-error-message" class="m-1 b-c-green" @click="hideMainErrorMessageModal('close')">Ok</b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import { DateTime } from 'luxon'
import { find, cloneDeep, first, orderBy, filter, endsWith, map, indexOf, trim, startsWith } from 'lodash'
import logKeys from "@/plugins/log-keys";

export default {
  name: 'Staff',
  created () {
    this.fetchData()
  },
  mounted () {
    this.$root.$on('change-lang', () => {
      if (this.$el.isConnected) {
        this.updateLinks()
        this.getOptions()
      }
    })
  },
  data () {
    const driverId = this.$route.query.vehicle
    const config = this.$route.meta.config

    return {
      config,
      driverId,
      originalDriverItems: [],
      driverItems: [],
      driverFields: [],
      drivingLicenseOptions: [],
      companyOptions: [],
      enabledDriverOptions: [],
      companyFilter: null,
      drivingLicenseFilter: null,
      enabledDriverFilter: null,
      links: [
        '/configuration/company',
        '/configuration/driving_license'
      ],
      showCollapse: false,
      infoItem: {},
      staffImportFile: null,
      enableImport: false,
      importErrors: []
    }
  },
  watch: {
    companyFilter (val) {
      this.driverItems = this.getItems(val, this.drivingLicenseFilter, this.enabledDriverFilter)
    },
    drivingLicenseFilter (val) {
      this.driverItems = this.getItems(this.companyFilter, val, this.enabledDriverFilter)
    },
    enabledDriverFilter (val) {
      this.driverItems = this.getItems(this.companyFilter, this.drivingLicenseFilter, val)
    }
  },
  methods: {
    clickedLink (link) {
      const driverId = this.driverFilter
      if (link.href === '/organization/registry_drivers' && driverId) {
        this.$router.push({ name: 'EditVehicle', params: { id: driverId } })
      } else if (link.href && link.href !== '/organization/registry_drivers') {
        this.$router.push(link.href)
      }
    },
    fetchData () {
      this.$root.$emit('activeLoader', true)
      this.getOptions().then(() => this.getDrivers().then(() => this.$root.$emit('activeLoader', false)))
    },
    getOptions () {
      const axiosArray = []
      this.getDriverFields()
      this.getDriverStatus()
      axiosArray.push(this.getEnum('driving_license', 'drivingLicenseOptions', true))
      axiosArray.push(this.getEnum('company', 'companyOptions', true))
      this.updateLinks()
      return Vue.myAll(axiosArray).then(r => r)
    },
    getDriverFields () {
      this.driverFields = [
        // config[crud], create - read - update - delete
        { key: 'edit', label: '', hideInTable: !this.config.u && !this.config.r },
        { key: 'delete', label: '', hideInTable: !this.config.d },
        { key: 'surname', label: this.$tc('message.surname', 1).toLowerCase(), sortable: true, sortDirection: 'desc' },
        { key: 'name', label: this.$tc('message.name', 1).toLowerCase(), sortable: true, sortDirection: 'desc' },
        { key: 'taxCode', label: this.$tc('message.taxCode', 1), sortable: true, sortDirection: 'desc' },
        { key: 'keyCode', label: this.$tc('message.keyCode', 1), sortable: true, sortDirection: 'desc', hideInTable: true },
        { key: 'badgeNumber', label: this.$tc('message.badgeNumber', 1), sortable: true, sortDirection: 'desc', hideInTable: true },
        { key: 'companyText', label: `ID ${this.$tc('message.company', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc' },
        { key: 'startContract', label: `${this.$tc('message.start', 1)} ${this.$tc('message.contract', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc', hideInTable: true },
        { key: 'endContract', label: `${this.$tc('message.end', 1)} ${this.$tc('message.contract', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc', hideInTable: true },
        { key: 'resignDate', label: `${this.$tc('message.date', 1)} ${this.$tc('message.resign', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc', hideInTable: true },
        { key: 'drivingLicenseText', label: `ID ${this.$tc('message.type2', 1).toLowerCase()} ${this.$tc('message.drivingLicense', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc' },
        { key: 'resignedText', label: this.$tc('message.resigned', 1), sortable: true, sortDirection: 'desc' }
      ]
    },
    getDriverStatus () {
      this.enabledDriverOptions = [
        { value: '', text: this.$t('message.selectOption') },
        { value: true, text: `${this.$t('message.yes')}` },
        { value: false, text: `${this.$t('message.no')}` }
      ]
    },
    getEnum (path, obj, selectionMessage) {
      const options = []
      return Vue.myGet(this, `/enums/${path}`, 'data').then((items) => {
        if (selectionMessage) {
          options.push({ value: '', text: items.length !== 0 ? this.$t('message.selectOption') : this.$t('message.noOption') })
        }
        items.forEach((item) => {
          options.push({ value: item.id, text: item.descr })
        })
        if (obj) {
          this[obj] = options
        }
        return options
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getDrivers () {
      const editedDriverOptions = []

      return Vue.myGet(this, '/drivers', 'drivers').then((drivers) => {
        drivers.forEach((driver) => {
          const editedDriverOption = driver
          const foundedDrivingLicence = driver.licenseType
            ? find(this.drivingLicenseOptions, obj => obj.value === driver.licenseType) : null
          const foundedCompany = driver.company
            ? find(this.companyOptions, obj => obj.value === driver.company) : null
          editedDriverOption.drivingLicenseText = foundedDrivingLicence ? foundedDrivingLicence.text : this.$tc('message.emptyValue', 1)
          editedDriverOption.companyText = foundedCompany ? foundedCompany.text : this.$tc('message.emptyValue', 1)
          editedDriverOption.resignedText = !driver.resignDate ? this.$t('message.no') : this.$t('message.yes')
          editedDriverOption.resigned = !!driver.resignDate
          editedDriverOptions.push(editedDriverOption)
        })
        this.driverItems = orderBy(editedDriverOptions, 'surname')
        this.originalDriverItems = cloneDeep(this.driverItems)
        return editedDriverOptions
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getItems (company, drivingLicense, removed) {
      let editedItems = cloneDeep(this.originalDriverItems)
      if (company !== undefined && company !== null && company !== '') {
        editedItems = filter(editedItems, obj => obj.company === company)
      }
      if (drivingLicense !== undefined && drivingLicense !== null && drivingLicense !== '') {
        editedItems = filter(editedItems, obj => obj.licenseType === drivingLicense)
      }
      if (removed !== undefined && removed !== null && removed !== '') {
        editedItems = filter(editedItems, obj => obj.resigned === removed)
      }
      return editedItems
    },
    pushToEdit (item) {
      item && item.id ? this.$router.push({ name: 'EditStaff', params: { id: item.id }, query: { vehicle: item.driverId } })
        : this.$router.push({ name: 'EditStaff', params: { id: 'new' } })
    },
    resetFilters () {
      this.driverFilter = ''
      this.drivingLicenseFilter = ''
      this.enabledDriverFilter = ''
      this.companyFilter = ''
      this.$refs.driversTable.resetSearch()
    },
    deleteSelected (id, descr) {
      const obj = {
        path: `/drivers/${id}`,
        description: descr,
        redirect: this.$route.path
      }

      this.$root.$emit('deleteItem', obj, 1)
    },
    updateLinks () {
      const links = []
      this.links.forEach(link => {
        links.push({ href: link })
      })
      this.$root.$emit('change-links', links)
    },
    driverFileImported (file) {
      if (file && file.name) {
        const xls = endsWith(file.name, 'xls')
        const xlsx = endsWith(file.name, 'xlsx')
        const ods = endsWith(file.name, 'ods')
        if (xls || xlsx || ods) {
          this.enableImport = true
        } else {
          Vue.warning(this, this.$t('warnings.onlyExcel'))
          this.enableImport = false
          if (this.$refs.importStaffFile) this.$refs.importStaffFile.reset()
        }
      }
    },
    startImport (file) {
      this.$root.$emit('activeLoader', true)
      new Promise((resolve) => {
        resolve(Vue.parseExcel(file))
      }).then(result => {
        const axiosArray = []
        const templatePage = result[1] || first(result)
        let goAhead = true

        if (first(templatePage) && Object.keys(first(templatePage)).length !== 0) {
          const allColumns = Object.keys(first(templatePage))
          const fields = this.driverFields
          const currentTableColumns = []
          let hasCurrentLang = false
          fields.forEach(field => {
            if (field.label !== '') currentTableColumns.push(field.label)
          })
          currentTableColumns.forEach(field => {
            if (!hasCurrentLang) {
              const foundedField = find(allColumns, obj => obj === field)
              if (foundedField) hasCurrentLang = true
            }
          })
          goAhead = hasCurrentLang

          if (!hasCurrentLang) {
            Vue.warning(this, this.$tc('warnings.fileHasDifferentLang'))
          }
        } else {
          goAhead = false
          Vue.warning(this, this.$tc('warnings.fileIsEmpty'))
        }

        if (goAhead) {
          templatePage.forEach((item) => {
            axiosArray.push(item)
          })

          axios.all(map(axiosArray, driver => this.checkDataToImport(driver)
          )).then((results) => {
            const errorDrivers = []
            const allDrivers = []
            results.forEach((result) => {
              const driver = result.driver
              const errors = result.errors
              const duplicateDriver = find(allDrivers, obj => obj.taxCode === driver.taxCode)
              const index = 2 + indexOf(results, result)
              const editedDriver = driver
              editedDriver.index = index
              allDrivers.push(editedDriver)
              if (duplicateDriver) {
                errorDrivers.push({ errors: [`${this.$tc('message.row', 1)}: ${duplicateDriver.index} ${this.$tc('message.isADuplicateOfRow', 1).toLowerCase()}: ${editedDriver.index}`] })
              }
              if (errors.length !== 0) {
                const editedErrors = []
                errors.forEach((error) => {
                  editedErrors.push(error)
                })
                errorDrivers.push({ driver: editedDriver, errors: editedErrors })
              }
            })
            this.closeImportModal()
            if (errorDrivers.length !== 0) {
              this.openImportModalError(errorDrivers)
            } else {
              this.$root.$emit('activeLoader', false)
              Vue.success(this, this.$t('message.importSuccess'))
              this.$router.push({ name: 'RefreshPage', params: { name: 'Staff' } })
            }
          })
        } else {
          this.$root.$emit('activeLoader', false)
        }
      })
    },
    checkDataToImport (driver) {
      const taxCodeRegex = new RegExp(/^[A-Za-z]{6}[0-9LMNPQRSTUV]{2}[A-Za-z]{1}[0-9LMNPQRSTUV]{2}[A-Za-z]{1}[0-9LMNPQRSTUV]{3}[A-Za-z]{1}$/g)
      const editedDriver = {}
      const errors = []
      let hasStart = false
      let hasEnd = false
      let hasResign = false

      const surname = driver[this.$tc('message.surname', 1).toLowerCase()]
      const name = driver[this.$tc('message.name', 1).toLowerCase()]
      const taxCode = driver[this.$tc('message.taxCode', 1)]
      const badgeNumber = driver[this.$tc('message.badgeNumber', 1)]
      const keyCode = driver[this.$tc('message.keyCode', 1)]
      const company = driver[`ID ${this.$tc('message.company', 1).toLowerCase()}`]
      const drivingLicence = driver[`ID ${this.$tc('message.type2', 1).toLowerCase()} ${this.$tc('message.drivingLicense', 1).toLowerCase()}`]
      let startContract = driver[`${this.$tc('message.start', 1)} ${this.$tc('message.contract', 1).toLowerCase()}`]
      let endContract = driver[`${this.$tc('message.end', 1)} ${this.$tc('message.contract', 1).toLowerCase()}`]
      let resignContract = driver[`${this.$tc('message.date', 1)} ${this.$tc('message.resign', 1).toLowerCase()}`]

      if (startContract && !isNaN(startContract)) startContract = this.getDateFromExcelDate(startContract)
      if (resignContract && !isNaN(resignContract)) resignContract = this.getDateFromExcelDate(resignContract)
      if (endContract && !isNaN(endContract)) endContract = this.getDateFromExcelDate(endContract)

      if (!surname || surname.length > 50 || trim(surname).length === 0) {
        errors.push(this.$t('errors.surnameLength'))
      } else {
        editedDriver.surname = surname
      }
      if (!name || name.length > 50 || trim(name).length === 0) {
        errors.push(this.$t('errors.nameLength'))
      } else {
        editedDriver.name = name
      }
      if (!taxCodeRegex.test(taxCode)) {
        errors.push(this.$t('errors.taxCode'))
      } else {
        editedDriver.taxCode = taxCode.toUpperCase()
      }
      if (badgeNumber && (isNaN(badgeNumber) ? badgeNumber.length > 20 : JSON.stringify(badgeNumber).length > 20)) {
        errors.push(this.$t('errors.badgeLength'))
      } else {
        editedDriver.badgeNumber = isNaN(badgeNumber) ? badgeNumber : JSON.stringify(badgeNumber)
      }
      if (keyCode && keyCode.length > 40) {
        errors.push(this.$t('errors.keyCodeError'))
      } else {
        editedDriver.keyCode = keyCode
      }
      if (company && !startsWith(company, '-')) {
        const foundedCompany = find(this.companyOptions, obj => trim(obj.text).toLowerCase() === trim(company).toLowerCase())
        if (foundedCompany) {
          editedDriver.company = foundedCompany.value
        } else {
          errors.push(`${this.$tc('message.insuranceCompany', 1)}: ${company}, ${this.$tc('message.notFound').toLowerCase()}`)
        }
      }
      if (drivingLicence && !startsWith(drivingLicence, '-')) {
        const foundedLicenseType = find(this.drivingLicenseOptions, obj => trim(obj.text).toLowerCase() === trim(drivingLicence).toLowerCase())
        if (foundedLicenseType) {
          editedDriver.licenseType = foundedLicenseType.value
        } else {
          errors.push(`${this.$tc('message.drivingLicense', 1)}: ${drivingLicence}, ${this.$tc('message.notFound').toLowerCase()}`)
        }
      }
      if (startContract) {
        if (DateTime.fromSQL(startContract).isValid) {
          hasStart = true
        } else {
          const subject = `${this.$t('message.date', 1).toLowerCase()} ${this.$t('message.start', 1).toLowerCase()}
             ${this.$t('message.contract', 1).toLowerCase()}`
          errors.push(`${subject}, ${this.$tc('errors.invalidDate').toLowerCase()}`)
        }
      }
      if (endContract) {
        if (DateTime.fromSQL(endContract).isValid) {
          hasEnd = true
        } else {
          const subject = `${this.$t('message.date', 1).toLowerCase()} ${this.$t('message.end', 1).toLowerCase()}
             ${this.$t('message.contract', 1).toLowerCase()}`
          errors.push(`${subject}, ${this.$tc('errors.invalidDate').toLowerCase()}`)
        }
      }
      if (resignContract) {
        if (DateTime.fromSQL(resignContract).isValid) {
          hasResign = true
        } else {
          const subject = `${this.$t('message.date', 1).toLowerCase()} ${this.$t('message.resign', 1).toLowerCase()}
             ${this.$t('message.contract', 1).toLowerCase()}`
          errors.push(`${subject}, ${this.$tc('errors.invalidDate').toLowerCase()}`)
        }
      }
      const start = hasStart ? DateTime.fromSQL(startContract) : null
      const end = hasEnd ? DateTime.fromSQL(endContract) : null
      const resign = hasResign ? DateTime.fromSQL(resignContract) : null

      if (hasStart && hasEnd && hasResign) {
        if (start <= end && start <= resign && resign <= end) {
          editedDriver.startContract = start.toSQLDate()
          editedDriver.endContract = end.toSQLDate()
          editedDriver.resignDate = resign.toSQLDate()
        } else {
          errors.push(this.$t('errors.invalidContractData'))
        }
      } else if (hasEnd && hasResign) {
        if (resign <= end) {
          editedDriver.endContract = end.toSQLDate()
          editedDriver.resignDate = resign.toSQLDate()
        } else {
          errors.push(this.$t('errors.invalidContractData'))
        }
      } else if (hasStart && hasResign) {
        if (start <= resign) {
          editedDriver.startContract = start.toSQLDate()
          editedDriver.resignDate = resign.toSQLDate()
        } else {
          errors.push(this.$t('errors.invalidContractData'))
        }
      } else if (hasStart && hasEnd) {
        if (start <= end) {
          editedDriver.startContract = start.toSQLDate()
          editedDriver.endContract = end.toSQLDate()
        } else {
          errors.push(this.$t('errors.invalidContractData'))
        }
      } else if (hasStart) {
        editedDriver.startContract = start.toSQLDate()
      } else if (hasEnd) {
        editedDriver.endContract = end.toSQLDate()
      } else if (hasResign) {
        editedDriver.resignDate = resign.toSQLDate()
      }
      if (errors.length === 0) {
        return this.updateDriverData(editedDriver)
      }
      return { errors, driver: editedDriver }
    },
    getDateFromExcelDate (serial) {
      // USE ONLY FOR DATE, DO NOT USE FOR TIMESTAMPS, IT DO NOT CARES OF HOURS, MINUTES, SECONDS, MILLISECONDS AND TIMEZONE
      const utcDays = Math.floor(serial - 25569)
      const utcValue = utcDays * 86400
      const dateInfo = new Date(utcValue * 1000)
      const date = new Date(dateInfo.getFullYear(), dateInfo.getMonth(), dateInfo.getDate())
      return DateTime.fromJSDate(date).toSQLDate()
    },
    updateDriverData (driver) {
      const foundedDriver = find(this.originalDriverItems, obj => obj.taxCode && driver.taxCode && trim(obj.taxCode).toLowerCase() === trim(driver.taxCode).toLowerCase())
      const dataId = foundedDriver ? foundedDriver.id : null
      // config[crud], create - read - update - delete
      if (!this.config.c && !dataId) {
        return { errors: [this.$tc('errors.noStaffAdd', 1)], driver }
      }
      if (!this.config.u && dataId) {
        return { errors: [this.$tc('errors.noStaffEdit', 1)], driver }
      }

      this.logData(dataId, !!dataId)

      return Vue.putOrPost(this, !(!dataId), `/drivers${dataId ? '/' + dataId : ''}`, driver, false).then(() => {
        return { errors: [], driver }
      }).catch(error => {
        return { errors: [Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())], driver }
      })
    },
    openImportModalError (errors) {
      this.importErrors = errors
      this.$refs.importModalErrors.show()
    },
    hideMainErrorMessageModal () {
      this.importErrors = []
      this.$refs.importModalErrors.hide()
      this.$router.push({ name: 'RefreshPage', params: { name: 'Staff' } })
    },
    showImportModal () {
      this.$refs.importModal.show()
      if (this.$refs.importStaffFile) this.$refs.importStaffFile.reset()
    },
    closeImportModal () {
      this.$refs.importModal.hide()
      this.staffImportFile = null
    },
    logData (driverId, put) {
      const logObj = Vue.getLogObj(this, put ? 'put' : 'post', '/organization/registry_staff')

      logObj.data.details = []

      if (driverId) logObj.data.details.push({text: 'message.driver', option: 1, value: driverId, key: logKeys.driver})

      Vue.myLogPost(logObj)
    }
  }
}
</script>
